import { render, staticRenderFns } from "./guide-backup.vue?vue&type=template&id=71ba537c"
import script from "./guide-backup.vue?vue&type=script&lang=js"
export * from "./guide-backup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports